/**
 * Shared login modal handling
 *
 * @copyright 2018 Linguistica 360
 */

import { Script, injector } from '../shared/injector.js';

import $ from 'jquery';
import MicroModal from 'micromodal';
import iziToast from 'izitoast';


injector.injectClass(class extends Script {
    onLoad() {
        MicroModal.init();

        $('.login-form').on('submit', this.$wrap(this.login));

        $('#show_password').on('change', () => {
            if ($('#show_password').is(':checked')) {
                $('#password').attr('type', 'text');
            } else {
                $('#password').attr('type', 'password');
            }
        });
    }

    login($form) {
        const $elements = $form.find(':input');

        // disable all inputs, a's etc
        $elements.prop('disabled', true);

        const username = $form.find('.login-username').val();
        const password = $form.find('.login-password').val();

        const re = /\S+@\S+\.\S+/i;
        if (!re.test(username)) {
            iziToast.error({
                title: "Looks like you didn't enter your email address.",
                message: 'Please try again.',
            });

            $elements.prop('disabled', false);
            return false;
        }

        $.post('/login', { username, password }).done((resp) => {
            const json = JSON.parse(resp);
            if (json.status === 'OK') {
                iziToast.success({ title: 'Login success' });
                location.reload();
            }
            else {
                iziToast.error({
                    title: 'Error signing in',
                    message: json.message,
                });

                $('.login-footer.small').hide();
                $('.login-footer.big').show();
            }
        }).fail(() => {
            iziToast.error({
                title: 'Error signing in',
                message: 'Could not authenticate: server error',
            });
        }).always(() => {
            // enable all inputs, a's etc
            $elements.prop('disabled', false);
        });

        return false;
    }
});
